/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

function TelegramIcon(props: IProps) {
  const { width = 36, height = 36, ...rest } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M18 5C10.824 5 5 10.824 5 18C5 25.176 10.824 31 18 31C25.176 31 31 25.176 31 18C31 10.824 25.176 5 18 5ZM24.032 13.84C23.837 15.894 22.992 20.886 22.563 23.187C22.381 24.162 22.017 24.487 21.679 24.526C20.925 24.591 20.353 24.032 19.625 23.551C18.481 22.797 17.831 22.329 16.726 21.601C15.439 20.756 16.271 20.288 17.012 19.534C17.207 19.339 20.535 16.31 20.6 16.037C20.609 15.9957 20.6078 15.9527 20.5965 15.9119C20.5852 15.8712 20.5641 15.8338 20.535 15.803C20.457 15.738 20.353 15.764 20.262 15.777C20.145 15.803 18.325 17.012 14.776 19.404C14.256 19.755 13.788 19.937 13.372 19.924C12.904 19.911 12.02 19.664 11.357 19.443C10.538 19.183 9.901 19.04 9.953 18.585C9.979 18.351 10.304 18.117 10.915 17.87C14.711 16.219 17.233 15.127 18.494 14.607C22.108 13.099 22.849 12.839 23.343 12.839C23.447 12.839 23.694 12.865 23.85 12.995C23.98 13.099 24.019 13.242 24.032 13.346C24.019 13.424 24.045 13.658 24.032 13.84Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default TelegramIcon;
